import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { athenaProvider, singleProvider, providers, provider, createProviderData, providerPatientView } from '../mockData/provider-data';
import { providerAvailability } from '../mockData/appointments-data';

const ProviderApi = [
  rest.get(`${API_ROOT}providers/`, (req, res, ctx) => {
    const userId = req.url.searchParams.get('userId');
    const patientId = req.url.searchParams.get('patientId');
    const orgId = req.url.searchParams.get('organizationId');
    const all = req.url.searchParams.get('all');

    if (userId === singleProvider.rows[0].id) {
      return res(ctx.json(singleProvider));
    }
    if (patientId) {
      return res(ctx.json(provider));
    }
    if (orgId) {
      return res(ctx.json(providers));
    }
    if (all) {
      return res(ctx.json(providers));
    }
    return res(ctx.json(providers));
  }),

  rest.get(`${API_ROOT}providers/${provider.rows[0].id}/availability`, (req, res, ctx) => {
    const appointmentType = req.url.searchParams.get('appointmentType');
    if (appointmentType) {
      return res(ctx.json(providerAvailability));
    }
    return res(ctx.json({}));
  }),
  rest.get(`${API_ROOT}providers/${providers.rows[0].id}`, (req, res, ctx) => res(ctx.json(singleProvider))),
  rest.get(`${API_ROOT}providers/${providers.rows[2].id}`, (req, res, ctx) => {
    const user = req.url.searchParams.get('user');
    if (user === 'true') {
      return res(ctx.json(providerPatientView));
    }
    return res(ctx.json(athenaProvider));
  }),
  rest.post(`${API_ROOT}providers`, (req, res, ctx) => res(ctx.json(createProviderData))),
];
export default ProviderApi;
